/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import styles from "./PiecePlayModeSelector.module.scss";
import PiecePlayModeSelectorButton from "ui/feature/piece-play/PiecePlayModeSelectorButton";

const piecePlayModeTypes: Array<{
    mode: PiecePlayMode,
    title: string
}> = [
    {
      mode: "on_sheet_note_by_note",
        title: "On Sheet Note by Note"
    },
    {
        mode: "simplified_note_by_note",
        title: "Simplified Note by Note"
    },
    {
        mode: "listen",
        title: "Listen to Song"
    },
    {
        mode: "export",
        title: "Export to Other Services"
    }
]

interface Props {
    selectedMode: PiecePlayMode;
    selectMode: (mode: PiecePlayMode) => void;
}

const PiecePlayModeSelector: React.FC<Props> = ({selectedMode, selectMode}) => {

    return (
        <div className={styles.container}>
            {piecePlayModeTypes.map((mode) => (
                <PiecePlayModeSelectorButton key={mode.mode} title={mode.title} piecePlayMode={mode.mode}
                                             selectMode={selectMode} selectedMode={selectedMode}/>))}
        </div>
    );
}

export default PiecePlayModeSelector;